"use strict";

(function () {
  var retenir = document.querySelector('.header-nav-retenir');
  if (!retenir) return;
  var sectorTrigger = retenir.querySelector('[data-retenir-panel="sectors"]');
  var sectorsPanel = retenir.querySelector('.header-nav-retenir-col-right');
  if (!sectorTrigger || !sectorsPanel) return;
  sectorTrigger.addEventListener('click', function (event) {
    if (window.matchMedia('(min-width: 900px)').matches) {
      return;
    }
    event.preventDefault();
    retenir.classList.toggle('is-sectors-open');
    sectorTrigger.classList.toggle('is-active');
  });
})();